module.exports = __webpack_public_path__ + "static/media/08.74c29369.jpg";